#import "../fragments/account-basic.graphql"

mutation SelectCreateAccount($account: AccountCreateInput!) {
    accountCreate(input: $account) {
        account {
            ...AccountBasic
        }
    }
}
